import React, { FC } from 'react';

import styled from '@emotion/styled';
import { variant,ComponentsType } from '@lucid/theme';

export interface NavbarContainerProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The available variants for the NavbarContainer component. */
  variant?: ComponentsType['Navbar']['Container'];
}

const StyledNavbarContainer = styled.div<NavbarContainerProps>(
  variant({
    scale: 'navbar.container',
    variants: {
      defaultVariant: {}
    }
  }),
  {
    label: 'navbarContainer',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 auto',
    position: 'relative'
  }
);

const NavbarContainer: FC<NavbarContainerProps> = ({
  className,
  variant = 'default',
  ...rest
}) => (
  <StyledNavbarContainer
    {...rest}
    className={className}
    variant={variant}
  />
);

export { NavbarContainer };
export default NavbarContainer;
